/** Rutas relativas al baseURL del api client (/api/v1). Usar con api.get/post/put/patch/delete para tener interceptores. */
export const API_PATHS = {
  AUTH_ME: '/auth/me',
  AUTH_REFRESH: '/auth/refresh',
  AUTH_REGISTER: '/auth/register',
  CLINICS: '/clinics',
  CLINIC_BY_ID: (id: number) => `/clinics/${id}`,
  CLINIC_USERS: (id: number) => `/clinics/${id}/users`,
  CLINIC_USER: (clinicId: number, userId: number) => `/clinics/${clinicId}/users/${userId}`,
  VETERINARIANS: '/veterinarians',
  VETERINARIAN_BY_USER_ID: (userId: number) => `/veterinarians/user/${userId}`,
  VETERINARIANS_BY_CLINIC: (clinicId: number) => `/veterinarians/clinic/${clinicId}`,
  USERS: '/users',
  USER_AUDIT_LOGS: '/users/audit-logs',
  USER_BY_ID: (id: number) => `/users/${id}`,
  USER_ACTIVATE: (id: number) => `/users/${id}/activate`,
  USER_DEACTIVATE: (id: number) => `/users/${id}/deactivate`,
  USER_RESET_PASSWORD: (id: number) => `/users/${id}/reset-password`,
  USER_VERIFY: (id: number) => `/users/${id}/verify`,
  USER_BLACKLIST: (id: number) => `/users/${id}/blacklist`,
  USER_UNBLACKLIST: (id: number) => `/users/${id}/unblacklist`,
  USER_ADMIN_SUBSCRIPTION: (id: number) => `/users/${id}/admin-subscription`,
  USER_EXTEND_TRIAL: (id: number) => `/users/${id}/extend-trial`,
  USER_REDUCE_TRIAL: (id: number) => `/users/${id}/reduce-trial`,
  USER_EXTEND_TRIAL_BULK: '/users/extend-trial-bulk',
  USER_RESET_AI_USAGE: (id: number) => `/users/${id}/reset-ai-usage`,
  USER_RESET_ALL_AI_USAGE: '/users/reset-all-ai-usage',
  SUBSCRIPTION_PLANS_ADMIN: '/subscriptions/plans?active_only=false',
  APP_RATINGS_MY: '/app-ratings/my',
  ADMIN_VERIPAGO_ANALYZE: '/admin/veripago/analyze',
} as const;
